import React, { useEffect } from 'react'
import { connect } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import NavbarTwo from '../../components/navbar/NavbarTwo';
import { getUserReportOne } from '../../redux/actions/AuthActions';
import Loader from '../../components/Loader';
import Message from '../../components/Message';

const UserReportDetailScreen = ({ getUserReportOne, userReportDetails }) => {

    const { id } = useParams()

    useEffect(() => {
        getUserReportOne(id)
    }, [getUserReportOne, id])

    const { loading, report, error } = userReportDetails;

    return (
        <div className='bg-gray-50 min-h-screen sen-font'>
            <NavbarTwo />
            <div className='container max-w-screen-xl mx-auto px-4'>
                <div className='my-10'>
                    <Link to='/admin/report' className='px-5 py-3 bg-gray-200 hover:bg-gray-300 rounded text-sm font-medium tracking-wider'>GO BACK </Link>
                </div>
                <h2 className='text-center my-7 uppercase text-3xl font-bold'>User Report</h2>
                {
                    loading ? <Loader /> : error ? < Message error msg={error} /> : (
                        <div className='shadow p-4 rounded'>
                            <div className='mb-3'><span className='font-bold text-[#e63946] mr-1'>Name:</span> {report.name}</div>
                            <div className='mb-3'><span className='font-bold text-[#e63946] mr-1'>Email:</span> {report.email}</div>
                            <div className=''>
                                <span className='font-bold text-[#e63946] mb-1'>Message:</span>
                                <div>{report.message}</div>
                            </div>
                        </div>
                    ) 
                }
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    userReportDetails: state.userReportDetails,
})

export default connect(mapStateToProps, { getUserReportOne })(UserReportDetailScreen);